/** Connector marks — same files as members /setup. */

export type McpClientSurface = {
  id: string;
  name: string;
  logoSrc: string;
};

const SURFACES: McpClientSurface[] = [
  { id: 'claude', name: 'Claude', logoSrc: '/connectors/claude-color.svg' },
  { id: 'chatgpt', name: 'ChatGPT', logoSrc: '/connectors/openai.svg' },
  { id: 'cursor', name: 'Cursor', logoSrc: '/connectors/cursor.svg' },
  { id: 'bolt', name: 'bolt.new', logoSrc: '/connectors/bolt.svg' },
  { id: 'base44', name: 'Base44', logoSrc: '/connectors/base44.png' },
  { id: 'lovable', name: 'Lovable', logoSrc: '/connectors/lovable.svg' },
  { id: 'v0', name: 'v0', logoSrc: '/connectors/v0.svg' },
  { id: 'replit', name: 'Replit', logoSrc: '/connectors/replit.svg' },
];

export function surfaceForClient(clientName: string): McpClientSurface | null {
  const n = clientName.trim().toLowerCase();
  if (!n) return null;
  let id: string | null = null;
  if (n.includes('claude')) id = 'claude';
  else if (n.includes('chatgpt') || n.includes('openai')) id = 'chatgpt';
  else if (n.includes('cursor')) id = 'cursor';
  else if (n.includes('bolt')) id = 'bolt';
  else if (n.includes('base44')) id = 'base44';
  else if (n.includes('lovable')) id = 'lovable';
  else if (n.includes('v0')) id = 'v0';
  else if (n.includes('replit')) id = 'replit';
  return id ? SURFACES.find((s) => s.id === id) ?? null : null;
}

/** Handshake + user-agent from the stored call — better than OAuth client_name. */
export function sourceHintFromCall(requestArgs: Record<string, unknown> | null): string {
  if (!requestArgs) return '';
  const init = requestArgs.initialize;
  const client =
    init && typeof init === 'object'
      ? (init as { client?: { name?: unknown; title?: unknown } }).client
      : null;
  const request =
    requestArgs.request && typeof requestArgs.request === 'object'
      ? (requestArgs.request as { user_agent?: unknown })
      : null;
  return [client?.name, client?.title, request?.user_agent]
    .filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
    .join(' ');
}

export function resolveCallSource(
  clientName: string,
  requestArgs: Record<string, unknown> | null,
): string {
  const hint = sourceHintFromCall(requestArgs);
  return (
    surfaceForClient(hint)?.name ??
    surfaceForClient(clientName)?.name ??
    clientName
  );
}
